(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('HelpDialogController', HelpDialogController);

	HelpDialogController.$inject = ['$mdDialog'];

	function HelpDialogController($mdDialog) {

		/* jshint validthis: true */
		var self = this;

		self.close = close;

		function close(){
			$mdDialog.hide();
		}

	}

})();
